import { RouteNames } from '@/data/routes';
import { createRoutes } from '@/utils/router-helper';
import { authGuard } from '@auth0/auth0-vue';
import nonPermittedActivity from '@/pages/legal/nonPermittedActivity.vue';
import AccountLayout from '@/components/layouts/AccountLayout.vue';

export default createRoutes({
  path: '/legal',
  component: AccountLayout,
  redirect: { name: 'home' },
  meta: {
    displayNav: true,
  },
  children: [
    {
      path: '/legal/non-permitted-activity',
      name: RouteNames.LEGAL.NON_PERMITTED_ACTIVITY,
      component: nonPermittedActivity,
      beforeEnter: authGuard,
    },
  ],
});
